import { useCallback } from 'react';
import emptyFunction from 'react-utils/emptyFunction';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { getIsEnabled } from 'automation-ui-canvas/flow/records/Flow/flowUtils';
import { getFlowName } from 'automation-ui-flow-core/flow/flowUtils';
import AutomationBuilderCard from 'automation-ui-flow-core/canvas/AutomationBuilderCard';
import UIButton from 'UIComponents/button/UIButton';
import { compose } from 'redux';
import { wireFlowById, wireFlowByUuid } from 'automation-ui-canvas/queries/flowQueries';
import UILoadingSpinner from 'UIComponents/loading/UILoadingSpinner';
import { jsx as _jsx } from "react/jsx-runtime";
const WorkflowCard = ({
  flow,
  onClick = () => emptyFunction,
  flowQuery,
  width,
  showIcon
}) => {
  const handleOnClick = useCallback(event => {
    onClick(flow.getFlowId())(event);
  }, [flow, onClick]);
  if (flowQuery.loading) {
    return /*#__PURE__*/_jsx(UILoadingSpinner, {
      grow: true
    });
  }
  if (!flow) {
    return null;
  }
  const headerLangKey = getIsEnabled(flow) ? 'action-features.common.workflowCard.header' : 'action-features.common.workflowCard.headerDisabled';
  return /*#__PURE__*/_jsx("div", {
    onClick: handleOnClick,
    children: /*#__PURE__*/_jsx(AutomationBuilderCard, {
      headerIcon: "workflows",
      headerTitle: /*#__PURE__*/_jsx(FormattedMessage, {
        message: headerLangKey
      }),
      content: /*#__PURE__*/_jsx(UIButton, {
        use: "link",
        onClick: emptyFunction,
        children: getFlowName(flow)
      }),
      titleUseTheme: "sorbet",
      width: width,
      showIcon: showIcon
    })
  });
};

/**
 * Using both decorators will cause the second to override the
 * flow and flowQuery props injected unless only one of either
 * flowId or flowUuid is passed in. Since the decorators will
 * exit early if one or the other isn't found, this is a safe
 * operation
 */
const ConnectedWorkflowCard = compose(wireFlowById, wireFlowByUuid)(WorkflowCard);
export default ConnectedWorkflowCard;